import { fromJS } from 'immutable';

const excludedShippingCountriesByBrand = fromJS({
    MANDO: ['JP']
});

export default excludedShippingCountriesByBrand;
